import { SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import { appearanceStyle, buildBtnDisabledOrLoading, sizeStyles } from 'src/ui/components/button/icon-only/button-utils';
import { ButtonIconBoxPropsType } from 'src/ui/components/button/icon-only/types';
import { withConfig } from 'src/withConfig';

export const ButtonIconBox = withConfig(theme => styled('button', { label: 'ButtonIconBox' }) <ButtonIconBoxPropsType>`
    ${({ appearance }): SerializedStyles => appearanceStyle(theme, appearance)}
    ${({ size }): SerializedStyles => sizeStyles(theme, size)}
    ${({ isDisabled, isLoading }): SerializedStyles | null => buildBtnDisabledOrLoading(isDisabled, isLoading)};
    align-items: center;
    border: 0;
    cursor: pointer;
    display: flex;
    font-weight: ${theme.star.button.common.typography.fontWeightPrimary};
    justify-content: center;
    margin: 0;
    overflow: hidden;
    position: relative;
    &::after {
        content: '';
        inset: 0;
        opacity: 0;
        position: absolute;
        transition: opacity .2s ease;
    }
    &:hover,
    &:active {
        &::after {
            opacity: 1;
        }
    }
`);
